/* eslint-disable import/prefer-default-export */
export const loadGLightbox = initializeGLightbox => {
  if (typeof GLightbox === "undefined") {
    const glightboxScript = document.createElement("script");
    glightboxScript.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/glightbox/dist/js/glightbox.min.js"
    );

    const glightboxCssLink = document.createElement("link");
    glightboxCssLink.rel = "stylesheet";
    glightboxCssLink.href = "https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css";
    document.head.appendChild(glightboxCssLink);

    glightboxScript.onload = function () {
      initializeGLightbox();
    };

    document.head.appendChild(glightboxScript);
  } else {
    initializeGLightbox();
  }
};
/* eslint-enable import/prefer-default-export */
